export const SUMMARY_FUND_ERROR = "SUMMARY_FUND_ERROR";
export const SUMMARY_FUND_EXITOSO = "SUMMARY_FUND_EXITOSO";
export const SUMMARY_FUND_LOADING = "SUMMARY_FUND_LOADING";
export const SUMMARY_FUND_CLEANER = "SUMMARY_FUND_CLEANER";

export const OPEN_MODAL_SIX_APORTS = "APORTES_SEIS_MESES";
